import Vue from 'vue'
import env from './clientEnv'

// toast封装
function toast(content) {
  if (env?.isVivoApp && window.WeiwoJSBridge) {
    window.WeiwoJSBridge.toast({
      tips: content,
      sec: '1'
    })
  } else {
    Vue.prototype.$toast(content)
  }
}

export default toast
